// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LrYA","top":"styles_top__2bUl6"};